import {type NavigationTreePlan} from 'client';

// TODO: replace ugly find with sideeffects with Map generator
export const getSiteCageName = (cageId: string, planTreeNavigation: NavigationTreePlan) => {
  // Keeping back compatibility
  const result: {siteId?: string; siteName?: string; cageName?: string} = {
    siteId: undefined,
    siteName: undefined,
    cageName: undefined,
  };

  // eslint-disable-next-line array-callback-return
  planTreeNavigation.sites?.find((site) => {
    // eslint-disable-next-line array-callback-return
    site.cages?.find((cage) => {
      if (cage.id === cageId) {
        result.siteId = site.id;
        result.siteName = site.name;
        result.cageName = cage.name;
        return true;
      }
    });
  });

  return result;
};
